/**
 * Dummy 4-level hierarchy for the filter sidebar (until API matches this shape).
 * Levels: topic → subtopic → chapter → subchapter (leaf filters).
 */

export const FILTER_TREE_LEVELS = [
  'Topic',
  'Subtopic',
  'Chapter',
  'Subchapter',
]

/** @typedef {{ id: string, label: string, children?: TreeNode[] }} TreeNode */

/** @type {TreeNode[]} */
export const DUMMY_FILTER_TOPIC_TREE = [
  {
    id: 'topic-algebra',
    label: 'Algebra',
    children: [
      {
        id: 'subtopic-linear',
        label: 'Linear relations',
        children: [
          {
            id: 'chapter-graphs',
            label: 'Graphs & slopes',
            children: [
              { id: 'sch-slope-int', label: 'Slope–intercept form' },
              { id: 'sch-parallel', label: 'Parallel & perpendicular' },
              { id: 'sch-point-slope', label: 'Point–slope' },
            ],
          },
          {
            id: 'chapter-systems',
            label: 'Systems of equations',
            children: [
              { id: 'sch-substitution', label: 'Substitution' },
              { id: 'sch-elimination', label: 'Elimination' },
            ],
          },
        ],
      },
      {
        id: 'subtopic-quadratic',
        label: 'Quadratics',
        children: [
          {
            id: 'chapter-factorising',
            label: 'Factorising',
            children: [
              { id: 'sch-common-factors', label: 'Common factors' },
              { id: 'sch-trinomials', label: 'Trinomials' },
              { id: 'sch-difference-sq', label: 'Difference of two squares' },
            ],
          },
          {
            id: 'chapter-formula',
            label: 'Quadratic formula',
            children: [
              { id: 'sch-discriminant', label: 'Discriminant' },
              { id: 'sch-roots', label: 'Roots & nature' },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'topic-trigonometry',
    label: 'Trigonometry',
    children: [
      {
        id: 'subtopic-unit-circle',
        label: 'Unit circle',
        children: [
          {
            id: 'chapter-ratios',
            label: 'Trig ratios',
            children: [
              { id: 'sch-sin-cos', label: 'Sine & cosine' },
              { id: 'sch-tan', label: 'Tangent' },
            ],
          },
          {
            id: 'chapter-identities',
            label: 'Identities',
            children: [
              { id: 'sch-pythagorean', label: 'Pythagorean identity' },
              { id: 'sch-double-angle', label: 'Double angle' },
            ],
          },
        ],
      },
      {
        id: 'subtopic-triangles',
        label: 'Triangles',
        children: [
          {
            id: 'chapter-solving',
            label: 'Solving triangles',
            children: [
              { id: 'sch-sine-rule', label: 'Sine rule' },
              { id: 'sch-cosine-rule', label: 'Cosine rule' },
              { id: 'sch-area', label: 'Area formulas' },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'topic-probability',
    label: 'Probability',
    children: [
      {
        id: 'subtopic-basic',
        label: 'Basic probability',
        children: [
          {
            id: 'chapter-events',
            label: 'Events',
            children: [
              { id: 'sch-and-or', label: 'AND / OR' },
              { id: 'sch-mutually-exclusive', label: 'Mutually exclusive' },
            ],
          },
        ],
      },
    ],
  },
]
